import { formatDuration } from '../../utils/formatters';
import { formatTime } from '../../utils/timeHelpers';

const StopCard = ({ stop, isLocked = false }) => {
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/0061837b-d31b-4bc9-b253-97f40228a2c8',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'StopCard.jsx:5',message:'StopCard rendered',data:{stopName:stop?.name,hasArrivalTime:!!stop?.arrival_time,hasDepartureTime:!!stop?.departure_time},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
  // #endregion
  return (
    <div className={`bg-white border p-3 ${isLocked ? 'border-gray-400' : 'border-gray-200'}`}>
      <div className="flex items-start justify-between mb-1">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <span className="text-sm font-light">{stop.name}</span>
            {isLocked && <span className="text-xs">🔒</span>}
          </div>
          <p className="text-xs font-light text-gray-500 mt-0.5">
            {formatTime(stop.arrival_time)} - {formatTime(stop.departure_time)}
          </p>
        </div>
        <span className="text-xs font-light text-gray-400">
          {formatDuration(stop.duration_minutes)}
        </span>
      </div>
      
      {stop.duration_reasoning && (
        <p className="text-xs font-light text-gray-500 mb-1">{stop.duration_reasoning}</p>
      )}

      {stop.transport_to_next && (
        <div className="mt-2 pt-2 border-t border-gray-200">
          <p className="text-xs font-light text-gray-500">
            To next: {stop.transport_to_next.mode === 'walk' ? '🚶 Walk' : '🚇 Transit'} 
            {' '}({formatDuration(stop.transport_to_next.duration_minutes)})
          </p>
          {stop.transport_to_next.notes && (
            <p className="text-xs font-light text-gray-400 mt-0.5">{stop.transport_to_next.notes}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default StopCard;

